import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#0C1B26] text-white pt-12 pb-6" data-id="element-611">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-612">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-613">
          {/* Company Info */}
          <div data-id="element-614">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qh74mEBb962nRk6qjvv9uT/Geometric_Logo_of_Bright_Pixxel_Studio.png" alt="Bright Pixxel Studios" className="h-14 mb-4" data-id="element-615" />
            <p className="text-white/70 text-sm mb-4" data-id="element-616">
              UK-based web design, e-commerce, and SEO services. Creating
              beautiful, high-performing websites that drive results.
            </p>
            <a href="mailto:info@bright-pixxel.com" className="flex items-center text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-617">
              <MailIcon size={16} className="mr-2" data-id="element-618" />
              info@bright-pixxel.com
            </a>
          </div>
          {/* Services */}
          <div data-id="element-619">
            <h3 className="text-lg font-bold mb-4" data-id="element-620">Services</h3>
            <ul className="space-y-2" data-id="element-621">
              <li data-id="element-622">
                <Link to="/services/web-design" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-623">
                  Web Design
                </Link>
              </li>
              <li data-id="element-624">
                <Link to="/services/ecommerce" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-625">
                  E-Commerce
                </Link>
              </li>
              <li data-id="element-626">
                <Link to="/services/branding" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-627">
                  Branding
                </Link>
              </li>
              <li data-id="element-628">
                <Link to="/services/seo" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-629">
                  SEO Services
                </Link>
              </li>
              <li data-id="element-630">
                <Link to="/services/maintenance" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-631">
                  Website Maintenance
                </Link>
              </li>
            </ul>
          </div>
          {/* Company */}
          <div data-id="element-632">
            <h3 className="text-lg font-bold mb-4" data-id="element-633">Company</h3>
            <ul className="space-y-2" data-id="element-634">
              <li data-id="element-635">
                <Link to="/about" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-636">
                  About Us
                </Link>
              </li>
              <li data-id="element-637">
                <Link to="/portfolio" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-638">
                  Portfolio
                </Link>
              </li>
              <li data-id="element-639">
                <Link to="/pricing" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-640">
                  Pricing
                </Link>
              </li>
              <li data-id="element-641">
                <Link to="/faq" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-642">
                  FAQ
                </Link>
              </li>
              <li data-id="element-643">
                <Link to="/contact" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-644">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          {/* Legal */}
          <div data-id="element-645">
            <h3 className="text-lg font-bold mb-4" data-id="element-646">Legal</h3>
            <ul className="space-y-2" data-id="element-647">
              <li data-id="element-648">
                <Link to="/privacy" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-649">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-650">
                <Link to="/terms" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-651">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-652">
                <Link to="/cancellation" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-653">
                  Cancellation Policy
                </Link>
              </li>
              <li data-id="element-654">
                <Link to="/policies" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-655">
                  All Policies
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {/* Bottom Bar */}
        <div className="pt-6 border-t border-white/10" data-id="element-656">
          <p className="text-white/70 text-sm text-center" data-id="element-657">
            © {currentYear} Bright Pixxel Studios. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}